import React, { useCallback, useRef, useEffect } from "react";
import { Message, Button, Input, Icon, Dropdown } from "semantic-ui-react";
import "./style.less";
import { useInput } from "../../../../common/hooks";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import {
  setDrawingOpts,
  setToPublishFenceCategory,
  setToPublishFenceName,
  publishSelectedGeofence,
  setErrorToastMessage,
  cancelEditSelectedGeofence
} from "../../../../redux/geofence/actions";
import FenceCoordsList from "../CreateGeofence/FenceCoordsList";
import { useHistory, useRouteMatch } from "react-router-dom";

const geofenceCategories = [
  {
    value: "SERVICEABLE_AREA",
    text: "Serviceable Area",
    key: "SERVICEABLE_AREA"
  },
  {
    value: "NON_SERVICEABLE_AREA",
    text: "Non Serviceable Area",
    key: "NON_SERVICEABLE_AREA"
  },
  {
    value: "BUDDY_BLOCK",
    text: "Buddy Block",
    key: "BUDDY_BLOCK"
  },
  {
    value: "WAREHOUSE_FENCE",
    text: "Warehouse fence",
    key: "WAREHOUSE_FENCE"
  }
];

function UpdateGeofence() {
  const dispatch = useDispatch();
  const history = useHistory();
  const match = useRouteMatch("/city/:cityName/geofences/");
  const drawingOpts = useSelector(
    ({ geofence }) => geofence.drawingOpts,
    shallowEqual
  );
  const toPublishFence = useSelector(
    ({ geofence }) => geofence.toPublishFence,
    shallowEqual
  );
  const editablePolygonPresent = useRef(toPublishFence !== null);
  if (!toPublishFence) {
    history.push(match.url);
  }

  // TODO: hacky logic to detect if a polygon moved from
  // editable to saved state. Can be improved
  useEffect(() => {
    if (!toPublishFence && editablePolygonPresent.current) {
      history.push(`${match.url}/update/success`);
    }
    editablePolygonPresent.current = toPublishFence !== null;
  }, [toPublishFence, history, match.url]);

  const [geoFenceInputVal, setGeofenceInputVal] = useInput(
    toPublishFence ? toPublishFence.properties.name : ""
  );

  const changeCategory = useCallback(
    (e, { value }) => {
      if (drawingOpts) {
        dispatch(
          setDrawingOpts({
            drawingMode: "polygon",
            fenceCategory: value,
            editable: true
          })
        );
      }
      if (toPublishFence) {
        dispatch(setToPublishFenceCategory(value));
      }
    },
    [dispatch, drawingOpts, toPublishFence]
  );

  const updateButtonHandler = useCallback(() => {
    if (!geoFenceInputVal) {
      dispatch(
        setErrorToastMessage("Area Name required. Please give it a name.")
      );
      return;
    }
    dispatch(setToPublishFenceName(geoFenceInputVal));
    dispatch(publishSelectedGeofence());
  }, [dispatch, geoFenceInputVal]);

  const cancelButtonHandler = useCallback(() => {
    dispatch(cancelEditSelectedGeofence());
    history.push(`${match.url}/`);
  }, [dispatch, match.url, history]);

  const startDrawMode = useCallback(() => {
    if (toPublishFence) {
      dispatch(
        setDrawingOpts({
          drawingMode: "polygon",
          fenceCategory: toPublishFence.properties.fenceCategory,
          editable: true
        })
      );
    }
  }, [toPublishFence, dispatch]);
  return toPublishFence ? (
    <div className="UpdateGeofence">
      <h2>
        Edit <br /> Geofence
      </h2>
      <label>Category</label>
      <Dropdown
        fluid
        className="inverted"
        placeholder="Select Category"
        selection
        onChange={changeCategory}
        value={toPublishFence.properties.fenceCategory}
        options={geofenceCategories}
      />
      <br />
      <label>Area Name</label>
      <Input
        fluid
        inverted
        placeholder="Area Name"
        value={geoFenceInputVal}
        onChange={setGeofenceInputVal}
      />

      <br />
      <br />
      {!drawingOpts && !toPublishFence ? (
        <Button onClick={startDrawMode} fluid primary type="submit">
          Start Drawing
        </Button>
      ) : null}
      <div className={!drawingOpts ? "drawingModeOff" : ""}>
        <Message icon>
          <Icon name="info circle" />
          <Message.Content>
            Click on the map to start plotting points of the polygon. Last point
            and the starting point should be same. Click on starting point to
            complete polygon.
          </Message.Content>
        </Message>
      </div>
      <FenceCoordsList />
      <Button
        fluid
        primary
        type="submit"
        className="publishButton"
        onClick={updateButtonHandler}
      >
        Update
      </Button>
      <Button
        fluid
        primary
        inverted
        type="submit"
        className="cancelButton"
        onClick={cancelButtonHandler}
      >
        Cancel
      </Button>
    </div>
  ) : null;
}

UpdateGeofence.defaultProps = {};

UpdateGeofence.propTypes = {};

export default UpdateGeofence;
